import { Reservation } from "../reservation.model";

export class RequestPassengerListStandby {
    departureAirport: string;
    departureDate: string;
    operatingCarrier: string;
    operatingFlightCode: string;
  
    constructor(reservation: Reservation) {
        this.departureAirport =  reservation.flightSummary?.currentSegment?.departureAirport;
        this.departureDate =  reservation.flightSummary?.currentSegment?.departureDateTime.split('T')[0];
        this.operatingCarrier =  reservation.flightSummary?.currentSegment?.operatingCarrier;
        this.operatingFlightCode =  reservation.flightSummary?.currentSegment?.flightNumber.split(' ')[1];
    }
  }